import { tns } from '../../libs/tiny-slider';

class Carousels {
	constructor() {
		this.init();
	}

	init() {
		this.carouselEls = Array.from(document.querySelectorAll('[data-ui-component="carousel"]'));
		this.carousels = [];

		if (this.carouselEls) {
			this.buildCarousels();
		}
	}

	buildCarousels() {
		this.carouselEls.forEach(carouselEl =>
			this.carousels.push(
				tns({
					container: carouselEl.querySelector('[data-ui-component="carousel-slides"]'),
					items: 1,
					slideBy: 1,
					autoplay: true,
					autoplayResetOnVisibility: false,
					controls: false,
					autoplayButton: false,
					autoplayButtonOutput: false,
					autoplayHoverPause: true,
					nav: true,
					navContainer: carouselEl.querySelector('[data-ui-component="carousel-nav"]'),
					touch: true,
					mouseDrag: false,
					loop: false
				})
			)
		);
	}
}

export default new Carousels();
